export const assetPaths = {
  root: 'assets',
};
